import { mapGetters } from 'vuex';

export const OpenedRouteMixin = {
    data() {
        return {
            openedRoute: null
        };
    },
    methods: {
        updateRoute() {
            // only update if we don't open nested urls
            if (
                this.openedRoute === null ||
                this.getCurrentRouteFullPath.indexOf(this.openedRoute) === -1
            ) {
                this.openedRoute = this.getCurrentRouteFullPath;
            }
        }
    },
    computed: {
        ...mapGetters(['getCurrentRouteFullPath'])
    },
    created() {
        this.updateRoute();
    },
    watch: {
        getCurrentRouteFullPath() {
            this.updateRoute();
        }
    }
};
